import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=d63e98be&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./styles/_carbon-forms.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./styles/_carbon-tables.scss?vue&type=style&index=1&prod&lang=scss&external"
import style2 from "./styles/bootstrap-carbon-overrides.scss?vue&type=style&index=2&prod&lang=scss&external"
import style3 from "./Main.vue?vue&type=style&index=3&id=d63e98be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63e98be",
  null
  
)

export default component.exports